export default function(value) {
	const number = new Intl.NumberFormat('ru-RU').format(value)
	return `${number} ₽`
}